export default{
    namespaced: true,
    state: {
      //navigation modals
        sidebar: {
          isSidebarVisible: false,
          isCollapsed: false,
          isMobile: false
        },
      //account modals
        login: false,
        logout: false,
        password: false,
        addUser: false,
        editUser: false,
        addRequest: false,
        editRequest: false,
        addAlert: false,
        editAlert: false,
        addReport: false,
        editReport: false,
        setStatus: false,
    },
    getters: {
    },
    mutations: {
      showModal(state, payload) {
        state[payload] = true;
      },
      hideModal(state, payload) {
        state[payload] = false;
      },
      toggleModal(state, modalName) {
        state[modalName] = !state[modalName];
      },
      setModal(state, { key, value }) {
        if (Object.prototype.hasOwnProperty.call(state, key)) {
          state[key] = !!value;
        }
      },
      toggleCollapse(state) {
        state.sidebar.isCollapsed = !state.sidebar.isCollapsed;
      },
      setSidebarCollapsed(state, isCollapsed) {
        state.sidebar.isCollapsed = isCollapsed;
      },
      setSidebarMobile(state, isMobile) {
        state.sidebar.isMobile = isMobile;
      },
      toggleSidebar(state) {
        state.sidebar.isSidebarVisible = !state.sidebar.isSidebarVisible;
      },
      setSidebarVisible(state, isVisible) {
        state.sidebar.isSidebarVisible = isVisible;
      },
    },
    actions: {
      closeModal({ commit }, modalName) {
        commit('hideModal', modalName);
      },
    },
    modules: {
    }
  }
